export interface GuestAccountFormValidation {
  usernameInvalid: boolean
  passwordInvalid: boolean
}

export function validateGuestAccountForm(
  username: string,
  password: string,
  editing: boolean,
): GuestAccountFormValidation {
  return {
    usernameInvalid: username.trim().length < 3,
    passwordInvalid: editing ? Boolean(password) && password.length < 12 : password.length < 12,
  }
}
